import __request__ from "routing/request";
export function suggestFieldValue(validationRequest) {
  return __request__("POST", "/search/suggest", validationRequest, {}, {
    "Accept": ["application/json"]
  });
}
export function suggestQueryStrings(limit) {
  return __request__("GET", "/search/suggest/query_strings", null, { "limit": limit }, {
    "Accept": ["application/json"]
  });
}
